import { Navigate, useNavigate } from 'react-router-dom'
import {
  alpha,
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { routes } from '@/router'
import { RedirectIfAuthenticated } from '../session-screen'
import { sessionButtonSx } from '../session-button'
import { AlumeLogo } from '../alume-logo'

export function WelcomePage() {
  const navigate = useNavigate()
  const theme = useTheme()
  const isDesktop = useMediaQuery('(min-width:900px)', { noSsr: true })

  if (isDesktop) {
    return <Navigate to={routes.session.signin} replace />
  }

  return (
    <RedirectIfAuthenticated>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          gap: 3.5,
          minHeight: '100dvh',
          px: 2.5,
          pt: 4,
          pb: 'calc(24px + env(safe-area-inset-bottom, 0px))',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          component="svg"
          viewBox="0 0 600 260"
          fill="none"
          stroke="currentColor"
          strokeWidth={1}
          sx={{
            position: 'absolute',
            top: '8%',
            left: '-20%',
            width: '140%',
            opacity: 0.2,
            pointerEvents: 'none',
          }}
        >
          {Array.from({ length: 14 }, (_, index) => (
            <path
              key={index}
              d={`M0 ${200 + index * 4} C160 ${40 + index * 6} 320 ${240 + index * 3} 600 ${30 + index * 7}`}
            />
          ))}
        </Box>

        <Box
          sx={{
            position: 'absolute',
            top: '28%',
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <AlumeLogo titleAccess="Alume" sx={{ width: 180, height: 45 }} />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.25,
            position: 'relative',
          }}
        >
          <Typography
            component="h1"
            sx={{ fontSize: '1.6rem', fontWeight: 500, textAlign: 'center' }}
          >
            Bem-vindo(a) à Alume
          </Typography>
          <Typography sx={{ opacity: 0.75, textAlign: 'center' }}>
            Contabilidade e serviços financeiros descomplicados para a sua
            jornada profissional
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            position: 'relative',
          }}
        >
          <Button
            size="large"
            onClick={() => navigate(routes.session.signin)}
            sx={sessionButtonSx({
              bgcolor: 'secondary.main',
              color: 'primary.dark',
              '&:hover': { bgcolor: 'secondary.light' },
            })}
          >
            Login
          </Button>
          <Button
            size="large"
            variant="outlined"
            onClick={() => navigate(routes.session.signup.name)}
            sx={sessionButtonSx({
              color: 'primary.contrastText',
              borderColor: alpha(theme.palette.common.white, 0.35),
              '&:hover': {
                borderColor: 'primary.contrastText',
              },
            })}
          >
            Ainda não sou cliente
          </Button>
        </Box>

        <Typography
          variant="caption"
          textAlign="center"
          sx={{ position: 'relative', opacity: 0.7 }}
        >
          Ao seguir, você está de acordo com os{' '}
          <Box component="span" sx={{ fontWeight: 500, color: 'inherit' }}>
            Termos de uso
          </Box>{' '}
          e{' '}
          <Box component="span" sx={{ fontWeight: 500 }}>
            Aviso de Privacidade
          </Box>
        </Typography>
      </Box>
    </RedirectIfAuthenticated>
  )
}
